import { Controller } from "@hotwired/stimulus";
import { basicSetup, EditorView } from "codemirror"
import { json } from "@codemirror/lang-json"
import { css } from "@codemirror/lang-css"
import { liquid } from "@codemirror/lang-liquid"
import { oneDark } from '@codemirror/theme-one-dark';
import { keymap } from "@codemirror/view";
import {indentWithTab} from "@codemirror/commands"

export default class extends Controller {
  static targets = ["editor", "input"]
  static values = { language: String, input: String }
  
  saveKeymap = keymap.of([
    indentWithTab,
    {
    key: "Mod-s",
    run: () => {
      const event = new CustomEvent('mod_s')
      this.element.dispatchEvent(event)
      return true;
    }
  }]);

  async connect() {
    this.editor = new EditorView({
      doc: this.inputElement.value,
      extensions: [
        basicSetup,
        oneDark,
        this.language(),
        this.saveKeymap,
        EditorView.updateListener.of((view) => {
          if (view.docChanged) { this.sync() }
        })
      ],
      parent: this.editorTarget,
    })

    this.inputElement.addEventListener("update", (e) => {
      if (e.detail.source === 'codemirror') return;
  
      this.editor.dispatch({
        changes: {
          from: 0,
          to: this.editor.state.doc.length,
          insert: this.inputElement.value
        }
      })
    })
  }

  disconnect() {
    this.editor.destroy()
  }

  sync() {
    this.inputElement.value = this.editor.state.doc.toString()
    const event  = new CustomEvent('update', { detail: { source: 'codemirror' } })
    this.inputElement.dispatchEvent(event)
  }

  language() {
    if (this.languageValue === "json") {
      return json()
    } else if (this.languageValue === "css") {
      return css()
    } else {
      return liquid()
    }
  }

  get inputElement() {
    return this.hasInputTarget ? this.inputTarget : document.getElementById(this.inputValue)
  }
}